import { render, staticRenderFns } from "./related_handle.vue?vue&type=template&id=14913294&scoped=true&"
import script from "./related_handle.vue?vue&type=script&lang=js&"
export * from "./related_handle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14913294",
  null
  
)

export default component.exports